const button = "_button_13vu4_8";
const destructive = "_destructive_13vu4_110";
const styles = {
  button,
  "icon-only": "_icon-only_13vu4_53",
  "has-icon": "_has-icon_13vu4_60",
  destructive
};
export {
  button,
  styles as default,
  destructive
};
//# sourceMappingURL=Button.module.css.js.map
